import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const MENTAL_HEALTH_LIST_QUERY_KEY = "MENTAL_HEALTH_LIST_QUERY_KEY";
export const MENTAL_HEALTH_TODAY_QUERY_KEY = "MENTAL_HEALTH_TODAY_QUERY_KEY";

export const useMentalHealthCheckinsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [MENTAL_HEALTH_LIST_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listMentalHealthCheckins.bind(this, patientUserId),
    enabled: !!patientUserId,
  });
};

export const useTodayMentalHealthCheckinQuery = (patientUserId) => {
  return useQuery({
    queryKey: [MENTAL_HEALTH_TODAY_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getTodaysMentalHealthCheckin.bind(this, patientUserId),
    enabled: !!patientUserId,
  });
};

const listMentalHealthCheckins = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hrmentalhealthapi",
    path: "/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};

const getTodaysMentalHealthCheckin = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hrmentalhealthapi",
    path: "/" + patientUserId + "/today",
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
